module.exports = __webpack_public_path__ + "static/media/marker_club.4127efd1.svg";